"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var SupportController = /*#__PURE__*/function (_PageController) {
  _inherits(SupportController, _PageController);
  function SupportController() {
    var _this;
    _classCallCheck(this, SupportController);
    _this = _callSuper(this, SupportController);
    _this.activeTabButton = null;
    _this.tabSection = $('section.support-tabs');

    // init animated arrows
    _this.arrows = new SectionArrows(_this.tabSection, true, true);
    _this.initButtons();
    _this.initButtonsMobile();
    if (_this.platform.isPhone() || _this.platform.isTablet()) {
      _this.initAnchorScroll(40);
    } else {
      _this.initAnchorScroll(-10);
    }
    var storeInit = new Store();
    $('.product[data-product-id="300914624"] .selectProductChk').prop('checked', true).trigger("change").hide();
    return _this;
  }

  /*
   * Init tab buttons
   */
  _createClass(SupportController, [{
    key: "initButtons",
    value: function initButtons() {
      var _this2 = this;
      var buttons = $('a.item', this.tabSection);
      $(buttons, this.tabs).click(function (e) {
        e.preventDefault();
        _this2.activeTabButton = $(e.currentTarget);
        if (_this2.activeTabButton.hasClass('active')) {
          buttons.removeClass('active');
          _this2.showDetailContent('default');
          _this2.centerTabButtonArrow();
        } else {
          buttons.removeClass('active');
          _this2.activeTabButton.addClass('active');
          var id = _this2.activeTabButton.data('id');
          _this2.updateTabButtonArrow();
          _this2.showDetailContent(id);
          /*setTimeout(() => {
          	NavigationUtils.scrollToElement(this.activeTabButton, -this.getHeaderHeight());
          }, 400);*/
        }
      });
      $(".item-custom-link").click(function () {
        var dataId = $(this).attr("data-id");
        $('.item[data-id="' + dataId + '"]').click();
      });
    }
  }, {
    key: "initButtonsMobile",
    value: function initButtonsMobile() {
      var _this3 = this;
      var buttons = $('a.item', $('section.support-tabs-mobile'));
      $(buttons, this.tabs).click(function (e) {
        e.preventDefault();
        _this3.activeTabButton = $(e.currentTarget);
        if (_this3.activeTabButton.hasClass('active')) {
          buttons.removeClass('active');
          _this3.hideDetailContent();
        } else {
          buttons.removeClass('active');
          _this3.activeTabButton.addClass('active');
          var id = _this3.activeTabButton.data('id');
          _this3.showDetailContent(id);
          setTimeout(function () {
            NavigationUtils.scrollToElement(_this3.activeTabButton, -_this3.getHeaderHeight());
          }, 400);
        }
      });
    }
  }, {
    key: "updateTabButtonArrow",
    value: function updateTabButtonArrow() {
      if (this.activeTabButton) {
        this.arrows.setPositionToElement(this.activeTabButton);
      }
    }
  }, {
    key: "centerTabButtonArrow",
    value: function centerTabButtonArrow() {
      this.arrows.center();
    }

    /*
     * Handle display of detail content
     */
  }, {
    key: "showDetailContent",
    value: function showDetailContent(id) {
      var detailSections = $('section.detail');
      var activeDetail = detailSections.filter('[data-id="' + id + '"]');
      detailSections.slideUp(300);
      activeDetail.slideDown(300);
    }
  }, {
    key: "hideDetailContent",
    value: function hideDetailContent() {
      var detailSections = $('section.detail');
      detailSections.slideUp(300);
    }
  }]);
  return SupportController;
}(PageController);